import { SyntheticEvent, useCallback, useState } from 'react';

export interface UseMenuOutput {
  anchorEl: Element | null;
  open: (event: SyntheticEvent) => void;
  close: () => void;
  isOpen: boolean;
}

export const useMenu = (): UseMenuOutput => {
  const [anchorEl, setAnchorEl] = useState<Element | null>(null);

  const open = useCallback(
    (event: SyntheticEvent) => {
      setAnchorEl(event.currentTarget);
    },
    [setAnchorEl],
  );

  const close = useCallback(() => {
    setAnchorEl(null);
  }, [setAnchorEl]);

  return {
    anchorEl,
    open,
    close,
    isOpen: !!anchorEl,
  };
};

export interface UseMenuButtonOutput {
  anchorEl: HTMLElement | null;
  open: (event: React.MouseEvent<HTMLButtonElement>) => void;
  close: () => void;
  isOpen: boolean;
}

/** Button & Menu state handling
 *
 * Enables utilizing certain properties of HTMLElement type anchorEl such as 'offsetWidth'
 */
export const useMenuButton = (): UseMenuButtonOutput => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const open = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    },
    [setAnchorEl],
  );

  const close = useCallback(() => {
    setAnchorEl(null);
  }, [setAnchorEl]);

  return {
    anchorEl,
    open,
    close,
    isOpen: !!anchorEl,
  };
};
